<template>
  <f7-card class="iec-card no-margin-horizontal" @click="$emit('open', event)">
    <f7-card-content>
      <div class="iec-badges">
        <f7-chip color="red" class="iec-badge" :text="$t('feed.important')" >
          <template #media>
            <f7-icon class="padding-left-half" f7="exclamationmark_triangle"/>
          </template>
          <!-- <f7-icon f7="pin" size="12" /> -->
        </f7-chip>
        <f7-badge v-if="event.type" :color="typeColor(event.type)" class="iec-badge padding-vertical">
          {{ typeLabel(event.type) }}
        </f7-badge>
      </div>
      <div class="iec-title">{{ event.title }}</div>
      <div v-if="event.description" class="iec-desc">{{ event.description }}</div>
      <div class="iec-meta">
        <span class="iec-meta-item">
          <f7-icon f7="calendar" size="14" />
          {{ formatEventDate(event) }}
        </span>
        <span v-if="event.location" class="iec-meta-item">
          <f7-icon f7="map" size="14" />
          {{ event.location }}
        </span>
      </div>
    </f7-card-content>
    <f7-card-footer>
      <f7-link class="iec-cta" @click="$emit('open', event)" >
       <span>{{ $t('feed.viewEvent') }}</span> 
        <f7-icon f7="chevron_right" />
      </f7-link>
    </f7-card-footer>
  </f7-card>
</template>

<script setup>
import { f7 } from 'framework7-vue'
import dayjs from '../../js/day.js'
import i18n from '../../js/i18n.js'
const { t } = i18n.global

defineProps({
  event: { type: Object, required: true },
})

defineEmits(['open'])

const EVENT_TYPES = [
  { value: 'MEETING', labelKey: 'calendar.types.MEETING', color: 'blue' },
  { value: 'DEADLINE', labelKey: 'calendar.types.DEADLINE', color: 'red' },
  { value: 'CAMPAIGN', labelKey: 'calendar.types.CAMPAIGN', color: 'orange' },
  { value: 'SOCIAL', labelKey: 'calendar.types.SOCIAL', color: 'green' },
  { value: 'FUNDRAISING', labelKey: 'calendar.types.FUNDRAISING', color: 'pink' },
  { value: 'TRAINING', labelKey: 'calendar.types.TRAINING', color: 'purple' },
  { value: 'VOTE', labelKey: 'calendar.types.VOTE', color: 'teal' },
  { value: 'REMINDER_ONLY', labelKey: 'calendar.types.REMINDER_ONLY', color: 'gray' },
]

function typeMeta(type) {
  return EVENT_TYPES.find((t) => t.value === type)
}

function typeColor(type) {
  const t = typeMeta(type)
  return t ? t.color : 'gray'
}

function typeLabel(type) {
  const meta = typeMeta(type)
  return meta ? t(meta.labelKey) : type
}

function formatEventDate(event) {
  if (!event || !event.startAt) return ''
  const d = dayjs(event.startAt)
  if (!d.isValid()) return ''
  return event.allDay ? d.format('DD/MM/YYYY') : d.format('DD/MM/YYYY HH:mm')
}
</script>

<style scoped>
.iec-card {
  border-radius: 14px;
  border: 1px solid rgba(201, 168, 76, 0.4);
  box-shadow: 0 2px 10px rgba(201, 168, 76, 0.12);
  cursor: pointer;
}
.iec-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.iec-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius:25px;
 
}
.iec-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--avocash-pit, #1c1c1e);
}
.iec-desc {
  font-size: 13px;
  color: var(--f7-on-surface-variant, #8e8e93);
  margin-top: 4px;
}
.iec-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.iec-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--f7-on-surface-variant, #8e8e93);
}
.iec-cta {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 600;
  color: var(--avocash-blue, #3b4fca);
}
</style>
